import React from "react";
import { useIntl } from "react-intl";
import { FieldError } from "react-hook-form";
import { Field } from "@smartling-ui/field";
import {
    InputGroup,
    InputGroupAddon,
    InputGroupInput,
    InputGroupText
} from "@smartling-ui/input-group";
import { Building2 } from "lucide-react";

import { MAX_COMPANY_NAME_LENGTH } from "../../constants";
import { ServerErrorMessage } from "../ServerErrorMessage";

import messages from "./messages";

type Props = {
    value: string;
    onChange: (...event: unknown[]) => void;
    onBlur: () => void;
    name: string;
    error?: FieldError;
    inputRef?: React.Ref<HTMLInputElement>;
    autoFocus?: boolean;
}

export function CompanyNameField({
    value,
    onChange,
    onBlur,
    name,
    error,
    inputRef,
    autoFocus
}: Props) {
    const intl = useIntl();

    return (
        <Field.Root invalid={!!error}>
            <Field.Label>
                {intl.formatMessage(messages.companyName)}
            </Field.Label>

            <InputGroup>
                <InputGroupAddon align="inline-start">
                    <InputGroupText>
                        <Building2 />
                    </InputGroupText>
                </InputGroupAddon>

                <InputGroupInput
                    aria-invalid={!!error}
                    data-testid="companyName"
                    autoComplete="organization"
                    placeholder={intl.formatMessage(messages.companyNamePlaceholder)}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    ref={inputRef}
                    name={name}
                    maxLength={MAX_COMPANY_NAME_LENGTH}
                    autoFocus={autoFocus}
                />
            </InputGroup>

            {error && (
                <Field.Error>
                    <ServerErrorMessage error={error} />
                </Field.Error>
            )}
        </Field.Root>
    );
}
